export const FREE_BET_STATUS = {
  pending: 1,
  accepted: 2,
  finished: 3,
};

export const FREE_BET_WIN_TYPES = {
  Win: 0,
  BetPlusWin: 1,
};
